<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none d-none" display="lg" />
      <b-link class="navbar-brand" to="/">
        <img class="navbar-brand-full" src="/img/brand/logo.png" width="89" height="25" alt="AdReplay Logo">
        <img class="navbar-brand-minimized" src="/img/brand/symbol.png" width="30" height="30" alt="AdReplay Logo">
      </b-link>
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/publishers">Publishers</b-nav-item>
        <b-nav-item class="px-3" to="/listings">Listings</b-nav-item>
        <b-nav-item class="px-3" to="/account">My Account</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto mr-2">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter>
          <SidebarNavLink name="Support" url="/support" icon="icon-info"  />
        </SidebarFooter>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <Messages />
        <div class="container">
          <router-view />
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div class="d-md-flex d-sm-block justify-content-between align-items-center w-100">
        <div>
          <span class="ml-1">&copy; 2018 AdReplay. All rights reserved.</span>
          <!-- <a href="https://adreplay.com">adreplay.com</a> -->
        </div>
        <div class="disclaimer">All trademarks and registered trademarks are the property of their respective owners.</div>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import Vue from 'vue'
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  SidebarNavLink,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import Messages from './Messages';

export default {
  name: 'Container',

  components: {
    AppHeader,
    AppSidebar,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarNavLink,
    SidebarMinimizer,
    Messages,
  },

  data() {
    return {
      nav: nav.items
    };
  },

  beforeRouteEnter(to, from, next){
    const { $API, $session } = new Vue()

    // Coming from login page, skip check
    if( from.path === '/login' && $session.get('token') ){
      next()
      return
    }

    // API call to check session is still good
    $API.v2.Users.LoginCheck()
    .then(() => next())
    .catch(() => {
      $session.clear()
      next('/login')
    })
  },

  computed: {
    name() {
      return this.$route.name;
    },

    list() {
      // Watch
      return this.$route.matched.filter((route) => {
        route.meta = route.meta || {}
        if( route.meta.label === false ){
          return false
        }

        return route.name || route.meta.label
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
